<template>
<!-- 二次确定提醒 公共弹窗组件 -->
<section>
  <el-dialog title="重要提示" :visible.sync="visible" width="30%" center>
    <div style="text-align: center;">
      <i class="el-icon-warning-outline" style="font-size: 100px;color: #facea8;"/>
      <div style="margin-top: 15px;">
        <span style="font-size: 22px;">{{content}}</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" class="footerbtn cancle">{{cancelText}}</el-button>
      <el-button type="danger" @click="ok" class="footerbtn">{{okText}}</el-button>
    </span>
  </el-dialog>
</section>
</template>
<script>
export default {
  name: "popUp",
  props: {
    // title: String,
    content: String,
    cancelText: {
      type: String,
      default: '取消'
    },
    okText: {
      type: String,
      default: '确定'
    }
  },
  data () {
    return {
      visible: false,
      // 
    }
  },
  methods: {
    // 初始化
    init () {
        // 。。。
    },
    ok() {
      this.$emit('ok');
      // this.visible = false;
    },
  },
  created() {
    this.init();
  }
}
</script>
<style scoped>
.footerbtn{
  padding: 0 3em;
  line-height: 3.2em;
}
</style>


// WEBPACK FOOTER //
// popUp.vue?b56273ea